class StoreLocator extends HTMLElement {
  constructor() {
    super();
    this.selectedCity = null;
    this.searchInput = null;
  }

  connectedCallback() {
    this.render();
    this.getNearbyLocation();
    this.getByPincode();
  }

  render() {
    const cities = this.querySelectorAll(".store-locator--city");
    const shops = document.querySelectorAll(".store-locator--inner");
    const emptyStore = document.querySelector(".store-locator--no-stores");
    this.searchInput = this.querySelector(".search-input");
    const wrapper = this.querySelector(".store-locator--wrapper");
    const scrollLeftBtn = this.querySelector(".scroll-arrow--left");
    const scrollRightBtn = this.querySelector(".scroll-arrow--right");

    if (!wrapper || !scrollLeftBtn || !scrollRightBtn) return;

    scrollLeftBtn.addEventListener("click", () => {
      const scrollAmount = 200;
      const targetScroll = wrapper.scrollLeft - scrollAmount;
      const clampedScroll = Math.max(0, targetScroll);

      wrapper.scrollTo({ left: clampedScroll, behavior: "smooth" });
    });

    scrollRightBtn.addEventListener("click", () => {
      const scrollAmount = 200;
      const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;
      const targetScroll = wrapper.scrollLeft + scrollAmount;
      const clampedScroll = Math.min(targetScroll, maxScrollLeft);

      wrapper.scrollTo({ left: clampedScroll, behavior: "smooth" });
    });

    if (cities.length === 0 || shops.length === 0) {
      return;
    }

    cities.forEach((city) => {
      city.addEventListener("click", () => {
        this.selectedCity = city.getAttribute("data-cityname");
        this.updateStoresVisibility(shops, cities, emptyStore);
        this.scrollToCity(city);
      });
    });

    if (cities.length > 0) {
      this.selectedCity = cities[0].getAttribute("data-cityname");
      this.updateStoresVisibility(shops, cities, emptyStore);
    }

    if (this.searchInput) {
      this.searchInput.addEventListener("input", (event) => {
        const errMessage = this.querySelector(".store-locator--errorMsg");
        errMessage.classList.add("hidden");
        const query = event.target.value.toLowerCase();
        this.filterCitiesAndStores(query, cities, shops, emptyStore);
      });
    }
  }
  getNearbyLocation() {
    const btnNearbyLocation = this.querySelector(
      ".nearby-location.btn span"
    );
    const errMessage = this.querySelector(".store-locator--errorMsg");

    btnNearbyLocation.addEventListener("click", () => {
      const loader = this.querySelector(".store-locator--loader");

      if (!navigator.geolocation) {
        errMessage.classList.remove("hidden");
        errMessage.textContent =
          "Sorry! Nearby location feature is not available at the moment";
        return;
      }

      if (loader) loader.classList.remove("hidden");

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          const apiKey = "pk.3a1f3b8686887d082d802d2221e86c94";
          const url = `https://us1.locationiq.com/v1/reverse.php?key=${apiKey}&lat=${lat}&lon=${lon}&format=json`;

          fetch(url)
            .then((res) => res.json())
            .then((data) => {
              if (loader) loader.classList.add("hidden");

              const userPincode = data.address?.postcode;
              if (!userPincode) {
                errMessage.classList.remove("hidden");
                errMessage.textContent = "Could not retrieve pincode.";
                return;
              }

              const allShops = document.querySelectorAll(
                ".store-locator--inner"
              );

              let nearestShop = null;
              let minDistance = Infinity;

              allShops.forEach((shop) => {
                const shopLat = parseFloat(shop.getAttribute("data-lat"));
                const shopLon = parseFloat(shop.getAttribute("data-lon"));
                if (isNaN(shopLat) || isNaN(shopLon)) return;

                const distance = this.getDistanceFromLatLonInKm(
                  lat,
                  lon,
                  shopLat,
                  shopLon
                );

                shop.setAttribute("data-distance", distance.toFixed(2));

                if (distance < minDistance) {
                  minDistance = distance;
                  nearestShop = shop;
                }
              });

              if (nearestShop) {
                errMessage.classList.add("hidden");

                // Clear all badges and distances
                allShops.forEach((shop) => {
                  shop
                    .querySelector(".badge__container")
                    ?.classList.add("hidden");
                  const distanceBadge = shop.querySelector(
                    ".custom--distance .pr__badge"
                  );
                  if (distanceBadge) distanceBadge.textContent = "";
                });

                // Show badge and distance on nearest shop
                const badge = nearestShop.querySelector(".badge__container");
                if (badge) {
                  badge.classList.remove("hidden");
                  const mainBadge = badge.querySelector(".pr__badge");
                  if (mainBadge) mainBadge.textContent = `Nearest Store`;
                }

                const distanceBadge = nearestShop.querySelector(
                  ".custom--distance .pr__badge"
                );
                if (distanceBadge) {
                  distanceBadge.textContent = `${minDistance.toFixed(
                    1
                  )} km away`;
                }

                const nearestCity = nearestShop.getAttribute("data-shopsname");
                const matchingCity = this.querySelector(
                  `.store-locator--city[data-cityname="${nearestCity}"]`
                );

                if (matchingCity) {
                  this.selectedCity = nearestCity;
                  this.updateStoresVisibility(
                    document.querySelectorAll(".store-locator--inner"),
                    this.querySelectorAll(".store-locator--city"),
                    document.querySelector(".store-locator--no-stores")
                  );
                  this.scrollToCity(matchingCity);
                } else {
                  errMessage.classList.remove("hidden");
                  errMessage.textContent =
                    "Sorry! No nearby stores available for this location";
                }
              } else {
                errMessage.classList.remove("hidden");
                errMessage.textContent =
                  "Sorry! No nearby stores available for this location";
              }
            })
            .catch((err) => {
              console.error("Reverse geocoding failed:", err);
              errMessage.classList.remove("hidden");
              errMessage.textContent = "Failed to get your location details.";
            });
        },
        (err) => {
          console.warn(`Geolocation error (${err.code}): ${err.message}`);
          if (loader) loader.classList.add("hidden");
          errMessage.classList.remove("hidden");
          errMessage.textContent = "Please allow location permission.";
        }
      );
    });
  }

  getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance;
  }

  getByPincode() {
    this.searchInput = this.querySelector(".search-input");
    const errMessage = this.querySelector(".store-locator--errorMsg");
    this.searchInput.addEventListener("input", (e) => {
      const regex = /^\d{6}$/;
      const value = e.target.value.trim();

      if (regex.test(value)) {
        const pincodeAPI = `https://api.postalpincode.in/pincode/${value}`;

        fetch(pincodeAPI)
          .then((res) => res.json())
          .then((data) => {
            const postOffice = data[0]?.PostOffice?.[0];

            if (postOffice) {
              const city = postOffice.District?.toLowerCase();
              const division = postOffice.Division?.toLowerCase();
              const block = postOffice.Block?.toLowerCase();

              let matchingCityElement = null;

              if (city) {
                matchingCityElement = this.querySelector(
                  `.store-locator--city[data-cityname="${city}"]`
                );
              }

              if (!matchingCityElement && division) {
                matchingCityElement = this.querySelector(
                  `.store-locator--city[data-cityname="${division}"]`
                );
              }

              if (!matchingCityElement && block) {
                matchingCityElement = this.querySelector(
                  `.store-locator--city[data-cityname="${block}"]`
                );
              }

              if (matchingCityElement) {
                this.selectedCity = matchingCityElement.dataset.cityname;

                const shops = document.querySelectorAll(
                  ".store-locator--inner"
                );
                const cities = this.querySelectorAll(".store-locator--city");
                const emptyStore = document.querySelector(
                  ".store-locator--no-stores"
                );

                this.updateStoresVisibility(shops, cities, emptyStore);
                this.scrollToCity(matchingCityElement);
              } else {
                errMessage.classList.remove("hidden");
                errMessage.textContent = `Sorry! No nearby stores available for this location`;
              }
            } else {
              errMessage.classList.remove("hidden");
              errMessage.textContent = `Sorry! No nearby stores available for this location`;
              throw new Error("PostOffice data not found.");
            }
          })
          .catch((err) => {
            errMessage.classList.remove("hidden");
            errMessage.textContent =
              "Sorry! Nearby location feature is not available at the moment for this pincode";
            console.error("API error:", err);
          });
      }
    });
  }

  updateStoresVisibility(shops, cities, emptyStore) {
    let storeVisible = false;
    if (emptyStore) {
      emptyStore.classList.add("hidden");
    }

    shops.forEach((shop) => {
      const shopName = shop.getAttribute("data-shopsname");

      if (this.selectedCity === shopName) {
        shop.classList.remove("hidden");
        storeVisible = true;
      } else {
        shop.classList.add("hidden");
      }
    });

    if (storeVisible) {
      if (emptyStore) {
        emptyStore.classList.add("hidden");
      }
    } else {
      if (emptyStore) {
        emptyStore.classList.remove("hidden");
      }
    }

    cities.forEach((city) => {
      city.classList.remove("active-city");
      if (city.getAttribute("data-cityname") === this.selectedCity) {
        city.classList.add("active-city");
      }
    });
  }

  filterCitiesAndStores(query, cities, shops, emptyStore) {
    const wrapper = this.querySelector(".store-locator--wrapper");

    if (!query) {
      cities.forEach((city, index) => {
        city.classList.remove("hidden", "active-city");
        if (index === 0) {
          city.classList.add("active-city");
          this.selectedCity = city.getAttribute("data-cityname");
        }
      });

      shops.forEach((shop) => {
        const shopName = shop.getAttribute("data-shopsname");
        if (shopName === this.selectedCity) {
          shop.classList.remove("hidden");
        } else {
          shop.classList.add("hidden");
        }
      });

      if (emptyStore) {
        emptyStore.classList.add("hidden");
      }
      if (wrapper) {
        wrapper.classList.remove("justify-center");
      }

      return;
    }

    query = query.toLowerCase();
    let visibleCityCount = 0;
    const matchingCities = [];

    if (emptyStore) {
      emptyStore.classList.add("hidden");
    }

    shops.forEach((shop) => {
      const shopName = shop.getAttribute("data-shopsname")?.toLowerCase();
      const shopPincode = shop.getAttribute("data-shop-pincode")?.toLowerCase();
      const shopLocation = shop.getAttribute("data-shop-state")?.toLowerCase();
      const cityName = shop.getAttribute("data-shopsname")?.toLowerCase();
      const displayName = shop
        .getAttribute("data-shop-displayname")
        ?.toLowerCase();

      if (
        shopName?.includes(query) ||
        shopPincode?.includes(query) ||
        shopLocation?.includes(query) ||
        displayName?.includes(query)
      ) {
        shop.classList.remove("hidden");
        if (!matchingCities.includes(cityName)) {
          matchingCities.push(cityName);
        }
      } else {
        shop.classList.add("hidden");
      }
    });

    cities.forEach((city) => {
      if (matchingCities.includes(city.getAttribute("data-cityname"))) {
        city.classList.remove("hidden");
        visibleCityCount++;
      } else {
        city.classList.add("hidden");
      }
    });

    if (visibleCityCount === 0 && emptyStore) {
      emptyStore.classList.remove("hidden");
    }
  }

  scrollToCity(city) {
    const wrapper = this.querySelector(".store-locator--wrapper");
    city.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });

    setTimeout(() => {
      wrapper.scrollTo({
        left: city.offsetLeft - wrapper.clientWidth / 2 + city.clientWidth / 2,
        behavior: "smooth",
      });
    }, 300);
  }
}

customElements.define("store-locator", StoreLocator);
